import { useQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { postWalletSearch } from 'services/WalletsService'

export const useWalletSearchQuery = req => {
  return useQuery(reactQueryKeys.postWalletSearch(req), () => postWalletSearch(req), {
    keepPreviousData: true,
    refetchOnWindowFocus: false,
  })
}
